import React from 'react';

// Helper function to generate a random background color
const randomBgColor = () => {
  const colors = [
    // 'bg-red-500',
    // 'bg-blue-500',
    // 'bg-green-500',
    // 'bg-yellow-500',
    // 'bg-purple-500',
    'bg-[#A04D95]',
    // 'bg-indigo-500',
    // 'bg-teal-500',
    // 'bg-orange-500',
    // 'bg-rose-500',
    // 'bg-emerald-500',
    // 'bg-cyan-500',
    // 'bg-lime-500',
    // 'bg-amber-500',
    // 'bg-violet-500',
    // 'bg-fuchsia-500',
    // 'bg-sky-500',
    // 'bg-gray-500',
    // 'bg-zinc-500',
    // 'bg-neutral-500',
    // 'bg-stone-500',
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};


const InitialsCircle = ({ fullName }) => {
  // Get first letter of first and last word
  const getInitials = (name) => {
    const words = name.trim().split(' ');
    if (words.length === 1) {
      return words[0][0].toUpperCase();
    } else {
      return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    }
  };

  const initials = getInitials(fullName);
  const bgColor = randomBgColor();

  return (
    <div className={`w-14 h-14 ${bgColor} rounded-full flex items-center justify-center text-white font-bold text-xl`}>
      {initials}
    </div>
  );
};

export default InitialsCircle;

